export const getDefaultToggleOptions = () => {
    return {
        handle: {
            diameter: 17,
            distance: 40
        },
        track: {
            activeColor: "#4CD964",
            width: 32,
            height: 19
        }
    }
}